import { Controller } from '@hotwired/stimulus';
import _ from 'lodash';

export default class CoursesFilterController extends Controller {
  static targets = ['search', 'spinner', 'checkbox', 'mobileClearTop', 'mobileClearBottom'];

  initialize () {
    this.filterInputChange = _.debounce(this.filterInputChange, 500);
  }

  connect () {
    this.setLoadingSpinner();
  }

  clearFilters () {
    const index = this.searchTarget.src.indexOf('?') === -1 ? this.searchTarget.src.length : this.searchTarget.src.indexOf('?');
    this.searchTarget.src = this.searchTarget.src.substring(0, index);
    this.updatePath(this.searchTarget.src);
    this.checkboxTargets.forEach((elem) => {
      elem.checked = false;
    });
  }

  schoolSelectChange (event) {
    this.selectChange(event, 'school_ids');
  }

  programTypeSelectChange (event) {
    this.selectChange(event, 'program_types');
  }

  startDateSelectChange (event) {
    this.selectChange(event, 'start_dates');
  }

  topicSelectChange (event) {
    this.selectChange(event, 'topics');
  }

  languageSelectChange (event) {
    this.selectChange(event, 'languages');
  }

  selectChange (event, type) {
    if (event.target.id.includes('mobile')) {
      this.mobileClearTopTarget.hidden = false;
      this.mobileClearBottomTarget.hidden = false;
    }
    const id = event.target.id.slice(event.target.id.lastIndexOf('-') + 1);

    if (event.target.checked) {
      if (this.searchTarget.src.includes(`${type}=`)) {
        this.searchTarget.src = this.insert(this.searchTarget.src, `${type}=`, `${id}%2C`);
      } else if (this.searchTarget.src.endsWith('&')) {
        this.searchTarget.src = `${this.searchTarget.src}${type}=${id}%2C`;
      } else if (!this.searchTarget.src.includes('?')) {
        this.searchTarget.src = `${this.searchTarget.src}?${type}=${id}%2C`;
      } else {
        this.searchTarget.src = `${this.searchTarget.src}&${type}=${id}%2C`;
      }
    } else {
      this.searchTarget.src = this.searchTarget.src.replace(`${id}%2C`, '');
    }
    this.updatePath(this.searchTarget.src);
    window.dispatchEvent(new CustomEvent('update-filter-pills'));
  }

  filterInputChange (event) {
    const { value } = event.target;
    const type = event.target.name;
    const url = this.searchTarget.src ? this.searchTarget.src : window.location.href;
    this.addTextFilterParam(new URL(url), type, value);
    this.selectChange(event, 'search');
  }

  addTextFilterParam (url, type, value) {
    const { searchParams } = url;
    searchParams.delete(this.pageParamValue);
    searchParams.set(type, value);
    this.searchTarget.src = url;
  }

  // eslint-disable-next-line class-methods-use-this
  insert (string, keyword, text) {
    const index = string.indexOf(keyword) + keyword.length;

    return string.substring(0, index) + text + string.substring(index, string.length);
  }

  // eslint-disable-next-line class-methods-use-this
  updatePath (src) {
    const pathnameIndex = window.location.href.indexOf('?') === -1 ? window.location.href.length : window.location.href.indexOf('?');
    const srcIndex = src.indexOf('?');
    const srcParams = srcIndex !== -1 ? src.substring(srcIndex, src.length) : '';

    window.history.replaceState(
      null, null,
      window.location.href.substring(0, pathnameIndex) + srcParams,
    );
  }

  // eslint-disable-next-line class-methods-use-this
  setLoadingSpinner () {
    document.addEventListener('turbo:before-fetch-request', () => {
      if (this.spinnerTarget) {
        this.spinnerTarget.hidden = false;
      }
    });
  }
}
